<template>
  <b-sidebar
    id="edit-live-sidebar"
    :visible="isEditLiveSidebarActive"
    bg-variant="white"
    sidebar-class="sidebar-lg"
    shadow
    backdrop
    no-header
    right
    @hidden="resetForm()"
    @change="(val) => $emit('update:is-edit-live-sidebar-active', val)"
  >
 
    <template #default="{ hide }">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          Editar live
        </h5>

        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hide"
        />
      </div>

      <info
        v-if="isInfoSidebarActive"
        :is-info-sidebar-active.sync="isInfoSidebarActive"
        @refresh="refresh()"
        @close="isInfoSidebarActive = false"
      />
      <!-- BODY -->
      <validation-observer
        class="full-height-form"
        ref="refFormObserver"
      >
        <!-- Form -->
        <b-form
          class="p-2"
          @submit.prevent="submit()"
          @reset.prevent="resetForm"
          enctype="multipart/form-data"
        >
          <!-- Título -->
          <validation-provider
            v-slot="{ errors }"
            name="title"
          >
            <b-form-group
              label="Título"
              label-for="title"
            >
              <b-form-input
                id="title"
                v-model="form.title"
                placeholder="Digite um título"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>

          <!-- Link -->
          <validation-provider
            v-slot="{ errors }"
            name="link"
          >
            <b-form-group
              label="Link"
              label-for="link"
            >
              <b-form-input
                id="link"
                v-model="form.link"
                placeholder="Insira um link"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>

          <!-- Streaming -->
          <validation-provider
            v-slot="{ errors }"
            name="streaming"
            rules="required"
          >
            <b-form-group
              label="Streaming"
              label-for="streaming"
            >
              <v-select
                id="streaming"
                v-model="form.streaming"
                :options="streamingOptions"
                placeholder="Escolha o streaming"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>

          <!-- Banner -->
          <validation-provider
            v-slot="{ errors }"
            name="banner"
            vid="banner"
          >
            <b-form-group
              label="Banner"
              label-for="banner"
            >
              <b-form-file
                v-model="form.banner"
                placeholder="Escolher o banner"
                drop-placeholder="Drop file here..."
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>

          <!-- Description -->
          <validation-provider
            v-slot="{ errors }"
            name="description"
            rules="required"
          >
            <b-form-group
              label="Descrição"
              label-for="description"
              :state="errors.length > 0 ? false : null"
            >
              <b-form-textarea
                id="description"
                v-model="form.description"
                placeholder="Digite a descrição da live"
                rows="3"
                max-rows="6"
                :state="errors.length > 0 ? false : null"
                style="height: 150px;"
              />

              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>
          
          <!-- Form Actions -->
          <div class="d-flex mt-2">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-2"
              type="submit"
              :disabled="isBusy"
            >
              <b-spinner v-if="isBusy" />
              <template v-else>
                Salvar
              </template>
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              type="button"
              variant="outline-secondary"
              @click="hide"
            >
              Cancelar
            </b-button>
          </div>
          <div class="d-flex justify-content-end">
            <b-button variant="danger" @click="del(live.id)" class="text-danger mt-1">
              <span class="align-middle ">Deletar</span>
              <feather-icon icon="InfoIcon" class="ml-50" />
            </b-button>
          </div>
        </b-form>
      </validation-observer>
    </template>
  </b-sidebar>
</template>
<script>
import axios from "axios";
import {
  BSidebar, BForm, BCard, BFormGroup, BFormInput, BButton, VBTooltip
} from 'bootstrap-vue'

import { ref } from '@vue/composition-api'

import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'
import { required, min_value as minValue } from 'vee-validate/dist/rules'
import Ripple from 'vue-ripple-directive'
import countries from '@/@fake-db/data/other/countries'
import { Money } from 'v-money'
import vSelect from 'vue-select'

extend('required', {
  ...required,
  message: 'Esse campo é obrigatório.',
})

extend('min_length_deposit', {
  ...minValue,
  message: 'O valor minímo para depositar é R$ 1,00.',
})

export default {
  components: {
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BButton,
    Money,
    vSelect,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
    'b-tooltip': VBTooltip,
  },
  props: {
    isEditLiveSidebarActive: {
      type: Boolean,
      required: true,
    },
    live: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isBusy: false,
      form: {
        title: null,
        link: null,
        streaming: null,
        banner: null,
        description: null,
      },
      streamingOptions: ['cloudflare', 'youtube', 'vimeo'],
    }
  },
  methods: {
    resetForm() {
      this.form = {
        title: null,
        link: null,
        streaming: null,
        banner: null,
        description: null,
      }
      this.$emit('close')
    },
    async submit() {
      try {

        const isValid = await this.$refs.refFormObserver.validate();

        if (!isValid) {
          return;
        }

        const formData = new FormData();

        formData.append("title", this.form.title);
        formData.append("link", this.form.link);
        if(this.form.banner) {
          formData.append("banner", this.form.banner);
        }
        formData.append("streaming", this.form.streaming);
        formData.append("description", this.form.description);

        this.isBusy = true;
        const response = await axios.post(process.env.VUE_APP_API + `/events/lives/update-live/${this.live.id}`, formData);
        this.isBusy = false;
        console.log(response)
        if (response.status === 200) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Operação efetuada com sucesso.",
              icon: "InfoIcon",
              variant: "success",
            },
          });

          this.$emit("close");
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              icon: "InfoIcon",
              title: "Erro",
              text: "ERROR: erro ao tentar gravar as informações",
              variant: "danger",
            },
          });
        }
      } catch (err) {
        this.isBusy = false;
        this.$toast({
          component: ToastificationContent,
          props: {
            icon: "InfoIcon",
            title: "Erro ao tentar gravar as informações",
            variant: "danger",
          },
        });
        console.error(err);
      }
    },

    sortByName(a, b) {
      if (a.text < b.text) {
        return -1
      }
      if (a.text > b.text) {
        return 1
      }
      return 0
    },
    sortByDate(a, b) {
      if (a.date < b.date) {
        return -1
      }
      if (a.date > b.date) {
        return 1
      }
      return 0
    },
    del(id) {
      this.$swal({
        title: 'Deseja deletar esta live?',
        text: 'Você não será capaz de reverte essa ação!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3b65f0',
        cancelButtonColor: '#c1c1c1',
        cancelButtonText: 'Não',
        confirmButtonText: 'Sim, desejo deletar!',
        showLoaderOnConfirm: true,
        preConfirm: () => axios.post(`${process.env.VUE_APP_API}/events/lives/delete-live/${id}`)
            .then(response => {
              console.log(response.data)
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Sucesso ao deletar!',
                  icon: 'InfoIcon',
                  variant: 'success',
                }
              })
              this.$emit('close')
              // this.getListParticipantes()
            })
            .catch(error => {
              console.log(error)
              console.log(this.rowData.id)
              this.$toast({
                component: ToastificationContent,
                props: {
                  icon: 'InfoIcon',
                  title: error.message,
                  variant: 'danger',
                }
              })
            }),
        allowOutsideClick: () => !this.$swal.isLoading()
      }).then((result) => {
        if (result.isConfirmed) {
          this.$swal.fire(
            'Deletada!',
            'Live deletada com sucesso.',
            'success'
          )

          reload()
        }
      })
    },
  },
  mounted() {
    this.form.title = this.live.title
    this.form.link = this.live.link
    this.form.streaming = this.live.streaming
    this.form.description = this.live.title
    console.log(this.form)
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

#add-new-live-sidebar {
  .vs__dropdown-menu {
    max-height: 200px !important;
  }
}

</style>
